import { isDevelopment } from "src/module/helpers"

class IdleManager {

    constructor() {
        this.timer = null
        this.timeout = 10 * 60 * 1000
        this.history = null
        this.started = false
        this.debug = isDevelopment

        this.events = [
            "mousemove",
            "mousedown",
            "keydown",
            "scroll",
            "touchstart",
            "click",
            "focus",
            "input"
        ]
    }

    log(message, data = null) {

        if (!this.debug) return

        const time = new Date().toISOString()

        console.log(
            `%c[IdleManager ${time}]`,
            "color:#1890ff;font-weight:bold",
            message,
            data || ""
        )

    }


    init({ timeout, history }) {

        if (!history) {
            console.error("IdleManager: history is required")
            return
        }


        /*  */
        if (this.started) {
            this.log("init skipped (already started)")
            return
        }

        this.timeout = timeout
        this.history = history



        this.log("IdleManager initialized", {
            timeout: this.timeout
        })

        if (this.activityHandler) {
            this.events.forEach(event => {
                window.removeEventListener(event, this.activityHandler)
            })
        }

        this.activityHandler = this.throttle(() => {
            this.log("User activity detected", event?.type)
            this.resetTimer()
        }, 500)



        this.events.forEach(event => {
            window.addEventListener(event, this.activityHandler)
            this.log("Listening event", event)
        })

        window.addEventListener("storage", this.syncTabs)
        document.addEventListener("visibilitychange", this.handleVisibilityChange)

        this.resetTimer()
        this.started = true
    }

    handleVisibilityChange = () => {

        if (!document.hidden) {
            this.log("Tab became active")
            this.resetTimer()
        }

    }

    resetTimer() {

        if (!this.history?.location) {
            this.log("resetTimer skipped (history missing)")
            return
        }
        if (this.isLocked()) {
            this.log("resetTimer skipped (already locked)")
            return

        }

        if (this.history?.location?.pathname === "/lock-screen") {
            this.log("resetTimer skipped (already on lock screen)")
            return
        }
        if (this.timer) {
            clearTimeout(this.timer)
            this.log("Existing timer cleared")
        }


        this.log("New idle timer started", {
            timeout: this.timeout
        })

        this.timer = setTimeout(() => {
            this.log("Idle timeout reached")
            this.lock()
        }, this.timeout)
    }

    lock() {

        if (this.isLocked()) {
            this.log("lock skipped (already locked)")
            return

        }

        this.log("LOCK TRIGGERED")

        const currentUrl = this.history.location.pathname + this.history.location.search

        localStorage.setItem("app_locked", "true")
        this.log("Saving callback url", currentUrl)

        // alert(JSON.stringify(currentUrl))
        // ⬇️ TAMBAHKAN DI SINI
        if (currentUrl !== "/lock-screen") {
            this.log("Saving callback url", currentUrl)
            localStorage.setItem("lock_callback_url", currentUrl)
        }


        if (this.history && this.history.location.pathname !== "/lock-screen") {
            this.log("Redirecting to /lock-screen")
            this.history.push("/lock-screen")
        }

    }
    getCallbackUrl() {

        const url = localStorage.getItem("lock_callback_url")
        this.log("Get callback url", url)
        return url || null
    }

    unlock() {

        this.log("Unlock triggered")

        localStorage.removeItem("app_locked")

        const callback = this.getCallbackUrl()

        localStorage.removeItem("lock_callback_url")

        this.resetTimer()

        if (this.history) {

            this.log("Redirecting to callback url", callback)
            if (callback)
                this.history.push(callback)
            else
                history.replace("/")
        }

    }

    // unlock() {

    //     this.log("Unlock triggered")

    //     localStorage.removeItem("app_locked")

    //     this.resetTimer()

    // }

    isLocked() {
        const locked = localStorage.getItem("app_locked") === "true"
        this.log("Check lock state", locked)
        return locked
    }
    syncTabs = (event) => {

        if (event.key !== "app_locked") return

        this.log("Sync event detected from another tab", event.newValue)

        // Cek apakah sudah di lock screen
        if (this.isLocked() && this.history?.location?.pathname !== "/lock-screen") {
            this.log("Redirecting due to tab sync")
            this.history.push("/lock-screen")
        } else if (!this.isLocked() && this.history?.location?.pathname === "/lock-screen") {
            // Jika tab lain unlock, redirect ke halaman sebelumnya
            const callback = this.getCallbackUrl()
            if (callback) {
                this.history.push(callback)
            }
            if (!callback) {
                this.history?.push("/dashboard")
            }
        }

    }

    stop() {

        this.log("Stopping IdleManager")

        if (this.timer) {
            clearTimeout(this.timer)
            this.log("Timer cleared")
        }

        this.events.forEach(event => {
            window.removeEventListener(event, this.activityHandler)
            this.log("Removed listener", event)
        })

        window.removeEventListener("storage", this.syncTabs)
        this.started = false

    }
    throttle(fn, wait) {

        let last = 0
        return (...args) => {
            const now = Date.now()
            if (now - last > wait) {

                last = now
                fn.apply(this, args)
            }
        }

    }

    destroy() {
        this.stop()
        this.history = null
        this.activityHandler = null
    }

}

export default new IdleManager()